import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  adaptDataToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import { mapOnlyAccountListToDto } from './mappers';
import type { OnlyAccountList } from './models';

export const retroactiveApplyEmisora = async (
  body: OnlyAccountList,
): Promise<GenericResponse<string>> => {
  try {
    const dto = mapOnlyAccountListToDto(body);
    const response = await wtClientApi.put<string>(
      '/onboarding/investment/account/partial-update-v2',
      dto,
    );

    return adaptDataToGenericResponse(response.data, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al aplicar la retroactividad en las cuentas de inversión',
    );
  }
};
